// Нормализация города: разные написания → каноническое название
const CITY_ALIASES: Record<string, string> = {
  // Москва
  мск: 'Москва',
  москва: 'Москва',
  moscow: 'Москва',
  // Санкт-Петербург
  спб: 'Санкт-Петербург',
  'спб.': 'Санкт-Петербург',
  'санкт-петербург': 'Санкт-Петербург',
  'санкт петербург': 'Санкт-Петербург',
  'санкт-петербур': 'Санкт-Петербург',
  'санкт - петербург': 'Санкт-Петербург',
  питер: 'Санкт-Петербург',
  'st. petersburg': 'Санкт-Петербург',
  'saint-petersburg': 'Санкт-Петербург',
  // Новосибирск
  нск: 'Новосибирск',
  новосибирск: 'Новосибирск',
  // Екатеринбург
  екб: 'Екатеринбург',
  екатеринбург: 'Екатеринбург',
  // Нижний Новгород
  нн: 'Нижний Новгород',
  'нижний новгород': 'Нижний Новгород',
  // Казань
  казань: 'Казань',
  // Самара
  самара: 'Самара',
  // Уфа
  уфа: 'Уфа',
  // Ростов-на-Дону
  ростов: 'Ростов-на-Дону',
  'ростов-на-дону': 'Ростов-на-Дону',
  ростовнадону: 'Ростов-на-Дону',
  // Краснодар
  краснодар: 'Краснодар',
  // Воронеж
  воронеж: 'Воронеж',
  // Пермь
  пермь: 'Пермь',
  // Волгоград
  волгоград: 'Волгоград',
}

export function normalizeCity(raw: string): string {
  const trimmed = raw.trim()
  if (!trimmed) return ''
  const key = trimmed.toLowerCase().replace(/\s+/g, ' ')
  return CITY_ALIASES[key] ?? trimmed
}

export const SEGMENT_OPTIONS = [
  'ВПК',
  'СБ',
  'Промэлектроника',
  'IT',
  'Связь',
  'Медицина',
  'Торговая организация',
  'Другое',
] as const
